// Canonical deal technology categories with keyword matching
// Maps free-text AI-generated technology values to canonical display labels

export const TECH_NORMALIZE_MAP = {
  // Solar
  'solar': 'Solar PV', 'solar pv': 'Solar PV', 'solar_pv': 'Solar PV', 'solar power': 'Solar PV',
  'solar energy': 'Solar PV', 'photovoltaic': 'Solar PV', 'pv': 'Solar PV', 'solar farm': 'Solar PV',
  'solar panel': 'Solar PV', 'solar module': 'Solar PV', 'concentrated solar': 'Solar PV', 'csp': 'Solar PV',
  'floating solar': 'Solar PV', 'agrivoltaics': 'Solar PV', 'bifacial solar': 'Solar PV',
  'rooftop solar': 'Solar PV', 'utility scale solar': 'Solar PV', 'solar installation': 'Solar PV',
  // Onshore Wind
  'onshore_wind': 'Onshore Wind', 'onshore wind': 'Onshore Wind', 'wind': 'Onshore Wind',
  'wind power': 'Onshore Wind', 'wind energy': 'Onshore Wind', 'wind farm': 'Onshore Wind',
  'wind turbine': 'Onshore Wind', 'onshore wind energy': 'Onshore Wind',
  // Offshore Wind
  'offshore_wind': 'Offshore Wind', 'offshore wind': 'Offshore Wind', 'floating wind': 'Offshore Wind',
  'offshore wind farm': 'Offshore Wind', 'offshore wind energy': 'Offshore Wind',
  'subsea': 'Offshore Wind', 'subsea services': 'Offshore Wind', 'offshore vessel': 'Offshore Wind',
  'cable laying': 'Offshore Wind', 'offshore installation': 'Offshore Wind',
  // Hydro
  'hydro': 'Hydro', 'hydroelectric': 'Hydro', 'hydropower': 'Hydro', 'pumped hydro': 'Hydro',
  'run of river': 'Hydro', 'tidal': 'Hydro', 'wave energy': 'Hydro', 'marine energy': 'Hydro',
  // Battery Storage
  'storage': 'Battery Storage', 'battery': 'Battery Storage', 'battery storage': 'Battery Storage',
  'energy storage': 'Battery Storage', 'bess': 'Battery Storage', 'lithium': 'Battery Storage',
  'battery cell': 'Battery Storage', 'battery cell manufacturing': 'Battery Storage',
  'battery cell production': 'Battery Storage', 'battery chemicals': 'Battery Storage',
  'battery energy storage': 'Battery Storage', 'battery manufacturing': 'Battery Storage',
  'battery recycling': 'Battery Storage', 'grid storage': 'Battery Storage',
  'stationary storage': 'Battery Storage', 'battery materials': 'Battery Storage',
  'li-ion': 'Battery Storage', 'lithium-ion': 'Battery Storage', 'sodium-ion': 'Battery Storage',
  // Hybrid
  'hybrid': 'Hybrid', 'solar wind': 'Hybrid', 'wind solar': 'Hybrid', 'solar storage': 'Hybrid',
  'wind storage': 'Hybrid', 'hybrid renewable': 'Hybrid',
  // Transmission
  'transmission': 'Transmission', 'grid': 'Transmission', 'power grid': 'Transmission',
  'transmission line': 'Transmission', 'interconnector': 'Transmission', 'hvdc': 'Transmission',
  'substation': 'Transmission', 'distribution': 'Transmission', 'smart grid': 'Transmission',
  'grid infrastructure': 'Transmission', 'power transmission': 'Transmission',
  'electricity transmission': 'Transmission', 'electrical infrastructure': 'Transmission',
  // Green Hydrogen
  'hydrogen': 'Green Hydrogen', 'green hydrogen': 'Green Hydrogen', 'green_hydrogen': 'Green Hydrogen',
  'h2': 'Green Hydrogen', 'electrolyzer': 'Green Hydrogen', 'electrolysis': 'Green Hydrogen',
  'fuel cell': 'Green Hydrogen', 'hydrogen fuel': 'Green Hydrogen',
  'hydrogen production': 'Green Hydrogen', 'hydrogen storage': 'Green Hydrogen',
  // Green Ammonia
  'green_ammonia': 'Green Ammonia', 'green ammonia': 'Green Ammonia', 'ammonia': 'Green Ammonia',
  'e-ammonia': 'Green Ammonia',
  // Biomass
  'biomass': 'Biomass', 'biogas': 'Biomass', 'bioenergy': 'Biomass', 'biopower': 'Biomass',
  'waste to energy': 'Biomass', 'waste-to-energy': 'Biomass', 'biofuel': 'Biomass',
  'renewable natural gas': 'Biomass', 'rng': 'Biomass', 'anaerobic digestion': 'Biomass',
  'landfill gas': 'Biomass', 'biomethane': 'Biomass',
  // Geothermal
  'geothermal': 'Geothermal', 'geothermal energy': 'Geothermal', 'geothermal power': 'Geothermal',
  // Gas
  'gas': 'Gas-fired Power', 'natural gas': 'Gas-fired Power', 'lng': 'Gas-fired Power',
  'gas-fired': 'Gas-fired Power', 'gas fired': 'Gas-fired Power', 'ccgt': 'Gas-fired Power',
  'gas turbine': 'Gas-fired Power', 'gas pipeline': 'Gas-fired Power', 'gas power': 'Gas-fired Power',
  'combined cycle': 'Gas-fired Power', 'gas infrastructure': 'Gas-fired Power',
  'gas processing': 'Gas-fired Power', 'gas storage': 'Gas-fired Power',
  // Nuclear
  'nuclear': 'Nuclear', 'nuclear power': 'Nuclear', 'nuclear energy': 'Nuclear', 'smr': 'Nuclear',
  'small modular reactor': 'Nuclear', 'nuclear reactor': 'Nuclear',
  // Oil & Gas
  'oil_gas': 'Oil & Gas', 'oil & gas': 'Oil & Gas', 'oil and gas': 'Oil & Gas',
  'petroleum': 'Oil & Gas', 'refinery': 'Oil & Gas', 'upstream': 'Oil & Gas',
  'downstream': 'Oil & Gas', 'midstream': 'Oil & Gas', 'oil': 'Oil & Gas',
  'crude': 'Oil & Gas', 'petrochemical': 'Oil & Gas',
  // Data Center
  'data_center': 'Data Center', 'data center': 'Data Center', 'data centre': 'Data Center',
  'datacenter': 'Data Center', 'colocation': 'Data Center', 'hyperscale': 'Data Center',
  'edge computing': 'Data Center', 'cloud infrastructure': 'Data Center',
  // AI Compute
  'ai_compute': 'AI Compute', 'ai compute': 'AI Compute', 'ai computing': 'AI Compute',
  'ai infrastructure': 'AI Compute', 'gpu': 'AI Compute', 'ai data center': 'AI Compute',
  'artificial intelligence': 'AI Compute',
  // Industrial
  'industrial': 'Industrial', 'heavy industry': 'Industrial', 'manufacturing': 'Industrial',
  'cement': 'Industrial', 'steel': 'Industrial', 'aluminum': 'Industrial',
  'chemicals': 'Industrial',
  // EV / Charging
  'ev': 'EV / Charging', 'electric vehicle': 'EV / Charging', 'ev charging': 'EV / Charging',
  'charging infrastructure': 'EV / Charging', 'charging station': 'EV / Charging',
  'ev infrastructure': 'EV / Charging', 'charging network': 'EV / Charging',
  // Transport & Logistics
  'transport': 'Transport & Logistics', 'transport infrastructure': 'Transport & Logistics',
  'road': 'Transport & Logistics', 'roads': 'Transport & Logistics', 'toll road': 'Transport & Logistics',
  'toll roads': 'Transport & Logistics', 'motorway': 'Transport & Logistics', 'highway': 'Transport & Logistics',
  'bridge': 'Transport & Logistics', 'bridges': 'Transport & Logistics', 'tunnel': 'Transport & Logistics',
  'rail': 'Transport & Logistics', 'railway': 'Transport & Logistics', 'railroad': 'Transport & Logistics',
  'metro': 'Transport & Logistics', 'tramway': 'Transport & Logistics', 'light rail': 'Transport & Logistics',
  'high speed rail': 'Transport & Logistics', 'freight rail': 'Transport & Logistics',
  'port': 'Transport & Logistics', 'ports': 'Transport & Logistics', 'seaport': 'Transport & Logistics',
  'container terminal': 'Transport & Logistics', 'shipping': 'Transport & Logistics',
  'maritime': 'Transport & Logistics', 'maritime infrastructure': 'Transport & Logistics',
  'airport': 'Transport & Logistics', 'airports': 'Transport & Logistics', 'aviation': 'Transport & Logistics',
  'logistics': 'Transport & Logistics', 'freight': 'Transport & Logistics',
  'concession': 'Transport & Logistics', 'road concession': 'Transport & Logistics',
  // Carbon / CCS
  'carbon capture': 'Carbon / CCS', 'ccs': 'Carbon / CCS', 'ccus': 'Carbon / CCS',
  'carbon': 'Carbon / CCS', 'carbon removal': 'Carbon / CCS', 'direct air capture': 'Carbon / CCS',
  // Hospitality
  'hospitality': 'Hospitality', 'hotel': 'Hospitality', 'hotels': 'Hospitality',
  'resort': 'Hospitality', 'resorts': 'Hospitality', 'lodging': 'Hospitality',
  'hotel investment': 'Hospitality', 'hotel acquisition': 'Hospitality',
  'hotel portfolio': 'Hospitality', 'hospitality real estate': 'Hospitality',
  'hotel development': 'Hospitality', 'serviced apartments': 'Hospitality',
  'hotel management': 'Hospitality', 'hotel asset': 'Hospitality',
  // Agriculture & Natural Resources
  'agriculture': 'Agriculture & Natural Resources', 'agribusiness': 'Agriculture & Natural Resources',
  'farming': 'Agriculture & Natural Resources', 'farm': 'Agriculture & Natural Resources',
  'irrigation': 'Agriculture & Natural Resources', 'forestry': 'Agriculture & Natural Resources',
  'timber': 'Agriculture & Natural Resources', 'natural resources': 'Agriculture & Natural Resources',
  'aquaculture': 'Agriculture & Natural Resources', 'food processing': 'Agriculture & Natural Resources',
  'agricultural infrastructure': 'Agriculture & Natural Resources', 'grain storage': 'Agriculture & Natural Resources',
  'rural infrastructure': 'Agriculture & Natural Resources', 'crop': 'Agriculture & Natural Resources',
  'fishery': 'Agriculture & Natural Resources',
  // Mining & Extractives
  'mining': 'Mining & Extractives', 'mining infrastructure': 'Mining & Extractives',
  'mineral': 'Mining & Extractives', 'minerals': 'Mining & Extractives',
  'quarry': 'Mining & Extractives', 'quarrying': 'Mining & Extractives',
  'ore': 'Mining & Extractives', 'smelting': 'Mining & Extractives',
  'copper': 'Mining & Extractives', 'gold mining': 'Mining & Extractives',
  'iron ore': 'Mining & Extractives', 'lithium mining': 'Mining & Extractives',
  'coal': 'Mining & Extractives', 'rare earth': 'Mining & Extractives',
  'critical minerals': 'Mining & Extractives', 'extractives': 'Mining & Extractives',
  'mine': 'Mining & Extractives',
  // Defense
  'defense': 'Defense', 'defence': 'Defense',
  'military': 'Defense', 'aerospace': 'Defense', 'aerospace & defense': 'Defense',
  'defense infrastructure': 'Defense', 'military base': 'Defense',
  'naval': 'Defense', 'shipbuilding': 'Defense',
  'armaments': 'Defense', 'defense contractor': 'Defense',
  'missile': 'Defense', 'weapons systems': 'Defense',
  'air defense': 'Defense', 'defense technology': 'Defense',
  // Telecom & Digital Infra
  'telecom': 'Telecom & Digital Infra', 'telecommunications': 'Telecom & Digital Infra',
  'fiber': 'Telecom & Digital Infra', 'fiber optic': 'Telecom & Digital Infra',
  'fibre': 'Telecom & Digital Infra', 'broadband': 'Telecom & Digital Infra',
  'digital infrastructure': 'Telecom & Digital Infra', 'telecom tower': 'Telecom & Digital Infra',
  'telecom towers': 'Telecom & Digital Infra', 'cell tower': 'Telecom & Digital Infra',
  'tower infrastructure': 'Telecom & Digital Infra', 'mobile network': 'Telecom & Digital Infra',
  '5g': 'Telecom & Digital Infra', 'subsea cable': 'Telecom & Digital Infra',
  'submarine cable': 'Telecom & Digital Infra', 'ftth': 'Telecom & Digital Infra',
  'connectivity': 'Telecom & Digital Infra', 'internet infrastructure': 'Telecom & Digital Infra',
  // Water & Waste
  'water': 'Water & Waste', 'wastewater': 'Water & Waste', 'water treatment': 'Water & Waste',
  'desalination': 'Water & Waste', 'waste': 'Water & Waste', 'waste management': 'Water & Waste',
  'recycling': 'Water & Waste', 'sewage': 'Water & Waste', 'water infrastructure': 'Water & Waste',
  'water utility': 'Water & Waste', 'water supply': 'Water & Waste', 'stormwater': 'Water & Waste',
  'solid waste': 'Water & Waste', 'landfill': 'Water & Waste', 'waste collection': 'Water & Waste',
  'water purification': 'Water & Waste', 'sanitation': 'Water & Waste',
};

/**
 * Normalize a technology string to its canonical category label.
 * Tries exact match, then underscore-replaced match, then substring match.
 * Returns "Other" if no match found.
 */
export function normalizeTech(tech) {
  if (!tech) return null;
  const key = tech.toLowerCase().trim().replace(/_/g, ' ');
  // Exact match
  if (TECH_NORMALIZE_MAP[key]) return TECH_NORMALIZE_MAP[key];
  // Try with underscores preserved
  const keyUnderscore = tech.toLowerCase().trim();
  if (TECH_NORMALIZE_MAP[keyUnderscore]) return TECH_NORMALIZE_MAP[keyUnderscore];
  // Keyword-based fallback: check if any map key (4+ chars) is contained in the value
  for (const [pattern, canonical] of Object.entries(TECH_NORMALIZE_MAP)) {
    if (pattern.length >= 4 && key.includes(pattern)) return canonical;
  }
  return 'Other';
}
